export default __webpack_public_path__ + "static/media/bg.055d0484.svg";